module.exports = __webpack_public_path__ + "img/60_3.ee91b3cd.png";